/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AlphaPickBarDto } from '../models';
// @ts-ignore
import type { AlphaPickSummary } from '../models';
// @ts-ignore
import type { SimulationResponse } from '../models';
/**
 * AlphaPicksApi - axios parameter creator
 * @export
 */
export const AlphaPicksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Daily OHLC bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {GetDailyBarsEntryTypeEnum} [entryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyBars: async (ticker: string, publishedAt: string, entryType?: GetDailyBarsEntryTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getDailyBars', 'ticker', ticker)
            // verify required parameter 'publishedAt' is not null or undefined
            assertParamExists('getDailyBars', 'publishedAt', publishedAt)
            const localVarPath = `/api/alpha-picks/{ticker}/{publishedAt}/daily`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)))
                .replace(`{${"publishedAt"}}`, encodeURIComponent(String(publishedAt)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entryType !== undefined) {
                localVarQueryParameter['entryType'] = entryType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 1-minute bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinuteBars: async (ticker: string, publishedAt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getMinuteBars', 'ticker', ticker)
            // verify required parameter 'publishedAt' is not null or undefined
            assertParamExists('getMinuteBars', 'publishedAt', publishedAt)
            const localVarPath = `/api/alpha-picks/{ticker}/{publishedAt}/minutes`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)))
                .replace(`{${"publishedAt"}}`, encodeURIComponent(String(publishedAt)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All picks ordered by pick order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-picks/portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cumulative $1,000 simulation from pick N
         * @param {number} [fromPickOrder] 
         * @param {GetSimulationEntryTypeEnum} [entryType] 
         * @param {GetSimulationStrategyEnum} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulation: async (fromPickOrder?: number, entryType?: GetSimulationEntryTypeEnum, strategy?: GetSimulationStrategyEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-picks/simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromPickOrder !== undefined) {
                localVarQueryParameter['fromPickOrder'] = fromPickOrder;
            }

            if (entryType !== undefined) {
                localVarQueryParameter['entryType'] = entryType;
            }

            if (strategy !== undefined) {
                localVarQueryParameter['strategy'] = strategy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger historical price backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBackfill: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-picks/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger priceAt1MinAfterPublish backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerMinuteBackfill: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-picks/backfill-minute-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manual sync trigger (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-picks/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlphaPicksApi - functional programming interface
 * @export
 */
export const AlphaPicksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlphaPicksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Daily OHLC bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {GetDailyBarsEntryTypeEnum} [entryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyBars(ticker: string, publishedAt: string, entryType?: GetDailyBarsEntryTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlphaPickBarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyBars(ticker, publishedAt, entryType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.getDailyBars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 1-minute bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinuteBars(ticker: string, publishedAt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlphaPickBarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinuteBars(ticker, publishedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.getMinuteBars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary All picks ordered by pick order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolio(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlphaPickSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolio(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.getPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cumulative $1,000 simulation from pick N
         * @param {number} [fromPickOrder] 
         * @param {GetSimulationEntryTypeEnum} [entryType] 
         * @param {GetSimulationStrategyEnum} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulation(fromPickOrder?: number, entryType?: GetSimulationEntryTypeEnum, strategy?: GetSimulationStrategyEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulation(fromPickOrder, entryType, strategy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.getSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger historical price backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerBackfill(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerBackfill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.triggerBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger priceAt1MinAfterPublish backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerMinuteBackfill(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerMinuteBackfill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.triggerMinuteBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manual sync trigger (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerSync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerSync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaPicksApi.triggerSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlphaPicksApi - factory interface
 * @export
 */
export const AlphaPicksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlphaPicksApiFp(configuration)
    return {
        /**
         * 
         * @summary Daily OHLC bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {GetDailyBarsEntryTypeEnum} [entryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyBars(ticker: string, publishedAt: string, entryType?: GetDailyBarsEntryTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlphaPickBarDto>> {
            return localVarFp.getDailyBars(ticker, publishedAt, entryType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 1-minute bars for one pick\'s holding period (% normalised)
         * @param {string} ticker 
         * @param {string} publishedAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinuteBars(ticker: string, publishedAt: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlphaPickBarDto>> {
            return localVarFp.getMinuteBars(ticker, publishedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All picks ordered by pick order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio(options?: RawAxiosRequestConfig): AxiosPromise<Array<AlphaPickSummary>> {
            return localVarFp.getPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cumulative $1,000 simulation from pick N
         * @param {number} [fromPickOrder] 
         * @param {GetSimulationEntryTypeEnum} [entryType] 
         * @param {GetSimulationStrategyEnum} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulation(fromPickOrder?: number, entryType?: GetSimulationEntryTypeEnum, strategy?: GetSimulationStrategyEnum, options?: RawAxiosRequestConfig): AxiosPromise<SimulationResponse> {
            return localVarFp.getSimulation(fromPickOrder, entryType, strategy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger historical price backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBackfill(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.triggerBackfill(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger priceAt1MinAfterPublish backfill Lambda (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerMinuteBackfill(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.triggerMinuteBackfill(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manual sync trigger (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerSync(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.triggerSync(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlphaPicksApi - object-oriented interface
 * @export
 * @class AlphaPicksApi
 * @extends {BaseAPI}
 */
export class AlphaPicksApi extends BaseAPI {
    /**
     * 
     * @summary Daily OHLC bars for one pick\'s holding period (% normalised)
     * @param {string} ticker 
     * @param {string} publishedAt 
     * @param {GetDailyBarsEntryTypeEnum} [entryType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public getDailyBars(ticker: string, publishedAt: string, entryType?: GetDailyBarsEntryTypeEnum, options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).getDailyBars(ticker, publishedAt, entryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 1-minute bars for one pick\'s holding period (% normalised)
     * @param {string} ticker 
     * @param {string} publishedAt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public getMinuteBars(ticker: string, publishedAt: string, options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).getMinuteBars(ticker, publishedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary All picks ordered by pick order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public getPortfolio(options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).getPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cumulative $1,000 simulation from pick N
     * @param {number} [fromPickOrder] 
     * @param {GetSimulationEntryTypeEnum} [entryType] 
     * @param {GetSimulationStrategyEnum} [strategy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public getSimulation(fromPickOrder?: number, entryType?: GetSimulationEntryTypeEnum, strategy?: GetSimulationStrategyEnum, options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).getSimulation(fromPickOrder, entryType, strategy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger historical price backfill Lambda (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public triggerBackfill(options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).triggerBackfill(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger priceAt1MinAfterPublish backfill Lambda (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public triggerMinuteBackfill(options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).triggerMinuteBackfill(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manual sync trigger (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaPicksApi
     */
    public triggerSync(options?: RawAxiosRequestConfig) {
        return AlphaPicksApiFp(this.configuration).triggerSync(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetDailyBarsEntryTypeEnum = {
    Publish: 'PUBLISH',
    Minute2: 'MINUTE2'
} as const;
export type GetDailyBarsEntryTypeEnum = typeof GetDailyBarsEntryTypeEnum[keyof typeof GetDailyBarsEntryTypeEnum];
/**
 * @export
 */
export const GetSimulationEntryTypeEnum = {
    Publish: 'PUBLISH',
    Minute2: 'MINUTE2'
} as const;
export type GetSimulationEntryTypeEnum = typeof GetSimulationEntryTypeEnum[keyof typeof GetSimulationEntryTypeEnum];
/**
 * @export
 */
export const GetSimulationStrategyEnum = {
    Hold: 'HOLD',
    Tp5: 'TP5',
    Tp10: 'TP10',
    Tp20: 'TP20',
    Tp30: 'TP30',
    TrailingStop: 'TRAILING_STOP',
    Tp10Hold: 'TP10_HOLD',
    TrailSwitch: 'TRAIL_SWITCH'
} as const;
export type GetSimulationStrategyEnum = typeof GetSimulationStrategyEnum[keyof typeof GetSimulationStrategyEnum];
